export default __webpack_public_path__ + "img/3e21fd3d6c12a010f539776872bc2688.png";